import 'antd-mobile/lib/toast/style/css';
import Toast from 'antd-mobile/lib/toast';
import share from '../../lib/utils/share';
import { openWithUrlParams, withErrReport } from '../../lib/utils';

function Share({ data: { title, desc, url, wording, jumpURL, icon, timeLineShowTitle }, meta }) {
  const shareCallback = () => {
    const jump = () => openWithUrlParams(jumpURL);

    if (wording && wording.trim()) {
      return Toast.success(wording, 2, jump);
    }

    jump();
  };

  let image;
  if (icon && icon.trim()) {
    const v = icon.trim();
    if (/^(https?:\/\/)/.test(v)) {
      image = v;
    } else if (/^(\/\/)/.test(v)) {
      image = `${window.location.protocol}${v}`;
    } else {
      image = `${window.location.protocol}//${v}`;
    }
  }

  share.init({
    flag: share.FLAG_MQQ + share.FLAG_WEIXIN,
    title: title && title.trim() ? title.trim() : meta.title,
    desc: desc && desc.trim() ? desc.trim() : meta.desc,
    url: url && url.trim() ? url.trim() : window.location.href,
    image,
    timeLineShowTitle,
    onShareWeiXinTimeline: shareCallback,
    onShareWeiXinFriend: shareCallback,
    onMQQShareBtnClick: shareCallback,
  });
}

export default withErrReport(Share);
